import { useState, useEffect, Fragment } from 'react';
import { scrapeWebsiteContent } from '../../utils/websiteScraper';

function RssSubscriptionCard({ subscription, onDelete, onRefresh, isRefreshing, isDeleting, onScraper, onShowConfirm, isScrapering }) {
    const [isExpanded, setIsExpanded] = useState(false);
    
    try {
        
        const formatDate = (dateString) => {
            try {
                return new Date(dateString).toLocaleString('zh-TW');
            } catch (error) {
                return 'Unknown Date';
            }
        };
        
        const handleRefresh = (e) => {
            e.stopPropagation();
            onRefresh(subscription);
        };
        
        const handleDelete = (e) => {
            e.stopPropagation();
            if (window.confirm('確定要取消訂閱此 RSS 源嗎？')) {
                onDelete(subscription);
            }
        };
        
        const toggleExpand = () => {
            setIsExpanded(!isExpanded);
        };

        return (
            <div className="bg-white rounded-lg border border-gray-200 overflow-hidden shadow-sm" data-name="subscription-card">
                <div 
                    className="p-4 cursor-pointer hover:bg-gray-50"
                    onClick={toggleExpand}
                    data-name="subscription-header"
                >
                    <div className="flex items-center justify-between">
                        <div className="flex items-center flex-1 min-w-0">
                            {subscription.feedImage ? (
                                <img 
                                    src={subscription.thumb} 
                                    alt={subscription.title}
                                    className="w-10 h-10 object-cover rounded mr-3"
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = 'https://via.placeholder.com/40?text=RSS';
                                    }}
                                    data-name="subscription-image"
                                />
                            ) : (
                                <div className="w-10 h-10 bg-orange-100 rounded flex items-center justify-center mr-3">
                                    <i className="fas fa-rss text-orange-500"></i>
                                </div>
                            )}
                            <div className="min-w-0 flex-1">
                                <h3 className="font-medium text-gray-900 truncate" data-name="subscription-title">
                                    <span className="relative">
                                        {subscription.title}
                                        <span className="absolute -top-1 -right-3 w-2 h-2 bg-red-500 rounded-full notification-dot"></span>
                                    </span>
                                </h3>
                                <div className="text-xs text-gray-500">
                                    <span className="mr-3" data-name="subscription-date">
                                        訂閱於 {formatDate(subscription.create_time)}
                                    </span>
                                    <span data-name="last-update">
                                        最後更新: {formatDate(subscription.update_time)}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="flex items-center ml-2">
                            <button
                                onClick={handleRefresh}
                                className="p-2 text-gray-500 hover:text-orange-600 mr-1"
                                disabled={isRefreshing}
                                title="更新內容"
                                data-name="refresh-button"
                            >
                                {isRefreshing ? (
                                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-orange-600"></div>
                                ) : (
                                    <i className="fas fa-sync-alt"></i>
                                )}
                            </button>
                            <button
                                onClick={handleDelete}
                                className="p-2 text-gray-500 hover:text-red-600"
                                disabled={isDeleting}
                                title="取消訂閱"
                                data-name="delete-button"
                            >
                                <i className="fas fa-trash"></i>
                            </button>
                            <div className="ml-2 text-gray-400">
                                <i className={`fas fa-chevron-${isExpanded ? 'up' : 'down'}`}></i>
                            </div>
                        </div>
                    </div>
                </div>
                
                {isExpanded && (
                    <div className="border-t border-gray-200 bg-gray-50 p-4" data-name="subscription-content">
                        {subscription.description && (
                            <div className="mb-4">
                                <h4 className="text-sm font-medium text-gray-700 mb-1">描述</h4>
                                <p className="text-sm text-gray-600">{subscription.description}</p>
                            </div>
                        )}
                        
                        <h4 className="text-sm font-medium text-gray-700 mb-2">最新文章</h4>
                        {subscription.items && subscription.items.length > 0 ? (
                            <ul className="bg-white rounded-lg border border-gray-200 overflow-hidden divide-y divide-gray-200">
                                {subscription.items.map((item, index) => (
                                    <li key={index} className="p-3 hover:bg-gray-50" data-name={`item-${index}`}>
                                        <a 
                                            href={item.link} 
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                            className="block"
                                        >
                                            <h5 className="font-medium text-gray-900 mb-1">
                                                <span className="relative inline-block">
                                                    { item.is_process ? <span className="text-red-500">[已處理] </span> : <></> }
                                                    {item.title}
                                                    { item.is_read == 0 ? <span className="absolute -top-1 -right-3 w-2 h-2 bg-red-500 rounded-full notification-dot"></span> : <></> }
                                                </span>
                                            </h5>
                                            {item.description && (
                                                <p className="text-sm text-gray-600 mb-2 line-clamp-2">{item.description}</p>
                                            )}
                                            <div className="flex justify-between items-center">
                                                <p className="text-xs text-gray-500">
                                                    {item.pub_time && formatDate(item.pub_time)}
                                                </p>

                                                <span className="text-blue-600 text-xs flex items-center" onClick={(e) => {
                                                    e.stopPropagation();
                                                    e.preventDefault();
                                                    // onScraper(e, item)
                                                    onShowConfirm(subscription.id, item.id, true)
                                                }}>
                                                    擷取內容
                                                    <i className="fas fa-sync mr-2"></i>
                                                </span>
                                            </div>
                                            
                                            { item.confirm ? <div className="mt-3 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                                                <p className="text-sm text-blue-700 mb-2">擷取內容後可在轉換記錄內進行相應處理。是否繼續？</p>
                                                <div className="flex justify-end space-x-2">
                                                    <button className="px-3 py-1 text-xs bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            onShowConfirm(subscription.id, item.id, false)
                                                        }}
                                                        disabled={isScrapering}>取消</button>
                                                    { isScrapering ? <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div> :
                                                    <button className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center"
                                                        onClick={async (e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            await onScraper(e, subscription.id, item)
                                                        }}
                                                    ><i className="fas fa-check mr-1"></i>確認</button> }
                                                </div>
                                            </div> : <></> }
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <div className="text-center py-8 bg-white rounded-lg border border-gray-200">
                                <p className="text-gray-500">無文章內容</p>
                            </div>
                        )}
                        
                        <div className="mt-4 text-right">
                            <a 
                                href={subscription.feedUrl} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="text-sm text-blue-600 hover:underline"
                                data-name="view-source-link"
                            >
                                <i className="fas fa-external-link-alt mr-1"></i>
                                查看原始 RSS 源
                            </a>
                        </div>
                    </div>
                )}
            </div>
        );
    } catch (error) {
        console.error('RssSubscriptionCard component error:', error);
        reportError(error);
        return null;
    }
}

export default RssSubscriptionCard;